// Arquivo: SideBar/SideBar.js
import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import * as S from "./SideBarStyle";
import { AuthContext } from "../../Context/AuthContext";
import { IoClose } from "react-icons/io5";
import { auditService } from "../../Services/auditService";

export default function SideBar({ NAV_LINKS, isExpanded, setExpanded }) {
  const { logout, authState } = useContext(AuthContext);

  const handleLogout = () => {
    logout();
  };

  // Nova função para lidar com o clique no link
  const handleLinkClick = async (link, event) => {
    if (link.permissionKey) {
      const viewPermissions = authState.viewPermissions;

      if (!viewPermissions || !viewPermissions[link.permissionKey]) {
        event.preventDefault(); // Impede a navegação
        alert("Você não tem permissão para acessar esta área.");
        return; // Para a execução
      }
    }

    // Se a permissão for válida ou não for necessária, continua
    setExpanded(false);
    await auditService.registerTabAccess(link.name);
  };

  return (
    <S.SideBarContainer expanded={isExpanded}>
      <S.CloseButton onClick={() => setExpanded(false)}>
        <IoClose />
      </S.CloseButton>

      <S.SidebarContent>
        <S.LogoContainer>
          <S.LogoLink to="/" onClick={() => setExpanded(false)}>
            <img src="logo-golden-ouro.png" alt="Company Logo" />
          </S.LogoLink>
        </S.LogoContainer>

        <S.NavItemsContainer>
          {NAV_LINKS.map((link) => (
            <S.NavItem key={link.name}>
              {/* O NavLink ainda é usado para estilização, mas o clique é interceptado */}
              <NavLink
                to={link.path}
                onClick={(event) => handleLinkClick(link, event)}
              >
                {link.name}
              </NavLink>
            </S.NavItem>
          ))}
        </S.NavItemsContainer>

        <S.NavFooter onClick={handleLogout}>LOGOUT</S.NavFooter>
      </S.SidebarContent>
    </S.SideBarContainer>
  );
}
